import React from 'react'

import { AvailableModules, Features } from 'generated/featureDefinitions'
import { PurchaseRequestsPageDocument } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import WithPaywall from 'modules/procurement/components/WithPaywall'
import PurchaseRequestsDataTable from 'modules/procurement/components/purchaseRequests/PurchaseRequestsDataTable'

const PurchaseRequestsPage = () => {
  const { loading, data, error } = useQuery(PurchaseRequestsPageDocument)

  useEffect(() => {
    track(trackingEvents.procurement.openPurchaseRequests)
  }, [])

  const [tab, setTab] = React.useState<string>('all')

  const onTabChange = (newTab: string) => {
    setTab(newTab)
  }

  const canManagePurchaseRequests = data?.procurement?._policies?.purchaseRequestManage.can ?? false

  return (
    <WithPaywall
      allowWhileLoading
      features={[Features.procurement_purchase_requests]}
      modules={[AvailableModules.procurement]}
    >
      {() => (
        <ResponsivePage.Body
          variant="full"
          authorized={canManagePurchaseRequests}
          loading={loading}
          error={error}
        >
          <PurchaseRequestsDataTable key={tab} tab={tab} onTabChange={onTabChange} />
        </ResponsivePage.Body>
      )}
    </WithPaywall>
  )
}

export default PurchaseRequestsPage
